<div class="chat">
  <ng-content></ng-content>
</div>
